import { createSelector } from '@reduxjs/toolkit';
import type {
  MarkerImage,
  MarkerLine,
  MarkerPin,
  MarkerPolygon,
  MarkerSurface,
  MarkerText,
} from 'minerva-plugin-api';
import { currentModelIdSelector } from '../models/models.selectors';
import { rootSelector } from '../root/root.selectors';
import {
  isMarkerImage,
  isMarkerLine,
  isMarkerPin,
  isMarkerPolygon,
  isMarkerSurface,
  isMarkerText,
} from './markers.utils';

export const markersSelector = createSelector(rootSelector, state => state.markers);

export const markersDataSelector = createSelector(markersSelector, markers => markers.data);

export const markersDataOfCurrentMapSelector = createSelector(
  markersDataSelector,
  currentModelIdSelector,
  (markers, modelId) => markers.filter(p => (p.modelId ? p.modelId === modelId : true)),
);

export const markerIdsSetSelector = createSelector(
  markersDataSelector,
  markers => new Set(markers.map(marker => marker.id)),
);

export const markersPinsOfCurrentMapDataSelector = createSelector(
  markersDataOfCurrentMapSelector,
  (markersData): MarkerPin[] => markersData.filter(isMarkerPin),
);

export const markersSurfaceOfCurrentMapDataSelector = createSelector(
  markersDataOfCurrentMapSelector,
  (markers): MarkerSurface[] => markers.filter(isMarkerSurface),
);

export const markersLinesCurrentMapDataSelector = createSelector(
  markersDataOfCurrentMapSelector,
  (markers): MarkerLine[] => markers.filter(isMarkerLine),
);

export const markersPolygonsCurrentMapDataSelector = createSelector(
  markersDataOfCurrentMapSelector,
  (markers): MarkerPolygon[] => markers.filter(isMarkerPolygon),
);

export const markersTextOfCurrentMapDataSelector = createSelector(
  markersDataOfCurrentMapSelector,
  (markers): MarkerText[] => markers.filter(isMarkerText),
);

export const markersImagesOfCurrentMapDataSelector = createSelector(
  markersDataOfCurrentMapSelector,
  (markers): MarkerImage[] => markers.filter(isMarkerImage),
);
